import * as htmlToImage from 'html-to-image'
import { toBlob } from 'html-to-image'

export function printChartById(divId) {
    const sourceElement = document.getElementById(divId)
    const frame1 = document.createElement('iframe')
    const frameName = 'frame1'

    frame1.name = frameName
    document.body.appendChild(frame1)

    const frameDoc = frame1.contentWindow.document

    frameDoc.open();
    frameDoc.write('<head><style>@media print { html, body { height: auto; margin: 0 !important; padding: 0 !important; } }</style></head><body></body>');
    frameDoc.close();

    const clonedContent = sourceElement.cloneNode(true)
    frameDoc.body.appendChild(clonedContent)

    window.frames[frameName].focus();
    window.frames[frameName].print();

    document.body.removeChild(frame1);
}

export function exportChartFromNode(node, fileName = 'Chart', context = null) {
    htmlToImage.toBlob(node, { fontEmbedCSS: '' })
        .then(blob => {
            const link = document.createElement('a')
            link.download = fileName
            link.href = URL.createObjectURL(blob)
            link.click()
            URL.revokeObjectURL(link.href)
        })
        .catch(error => {
            console.error('Chart export failed: ', error)
            if (context && context.$snackbars) {
                context.$snackbars.$emit('new', {text: 'Unable to export chart', usage: 'warning'})
            }
        })
}

export function exportCSV(chart, fileName = 'Chart', options = {}) {
    const {
        addPercentageSeries = false,
        beforeExport = null,
        afterExport = null
    } = options

    if (beforeExport) {
        beforeExport(chart)
    }

    const tempSeriesIds = []

    if (addPercentageSeries) {
        chart.series.forEach((serie, index) => {
            if (serie.type !== 'line' && !serie.symbol) {
                const data = []
                serie.data.forEach(d => {
                    data.push({y: Math.round(d.percentage), category: d.category})
                })
                const seriesId = 'percentage_' + index
                chart.addSeries({
                    name: '% ' + serie.name,
                    data: data,
                    id: seriesId
                }, false)
                tempSeriesIds.push(seriesId)
            }
        })
    }

    const chartData = "data:text/csv;charset=utf8," + chart.getCSV()
    const encodedUri = encodeURI(chartData)
    const link = document.createElement("a")
    link.setAttribute("href", encodedUri)
    link.setAttribute("download", fileName + ".csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    if (addPercentageSeries) {
        tempSeriesIds.forEach(seriesId => {
            const series = chart.get(seriesId)
            if (series) {
                series.remove()
            }
        })
    }

    if (afterExport) {
        afterExport(chart)
    }
}

export function downloadAsPDF(elementOrId, options = {}) {
    const {
        landscape = true,
        delay = 500
    } = options

    return new Promise((resolve) => {
        setTimeout(() => {
            const element = typeof elementOrId === 'string'
                ? document.getElementById(elementOrId)
                : elementOrId

            const iframe = document.createElement('iframe')
            iframe.style.position = 'absolute'
            iframe.style.width = '0'
            iframe.style.height = '0'
            iframe.style.border = 'none'
            document.body.appendChild(iframe)

            const iframeDoc = iframe.contentWindow.document
            iframeDoc.open()

            const landscapeRule = '@page {size:landscape !important; -webkit-print-color-adjust: exact !important; margin: 10px;}'
            const portraitRule = '@page {size:portrait !important; -webkit-print-color-adjust: exact !important; margin: 10px;}'
            const extraRule = '@media print {body{-webkit-print-color-adjust: exact !important;}}'
            const bodyRule = 'body { margin: 0; padding: 10px; }'

            let styleSheets = ''
            Array.from(document.styleSheets).forEach(sheet => {
                try {
                    if (sheet.href) {
                        styleSheets += `<link rel="stylesheet" href="${sheet.href}">`
                    } else if (sheet.cssRules) {
                        const rules = Array.from(sheet.cssRules).map(rule => rule.cssText).join('\n')
                        styleSheets += `<style>${rules}</style>`
                    }
                } catch (e) {
                    console.warn('Could not access stylesheet:', e)
                }
            })

            const html = `
                <html>
                <head>
                    ${styleSheets}
                    <style type="text/css" media="print">
                        ${landscape ? landscapeRule : portraitRule}
                        ${extraRule}
                        ${bodyRule}
                    </style>
                </head>
                <body>
                </body>
                </html>
            `

            iframeDoc.write(html)
            iframeDoc.close()

            const clonedContent = element.cloneNode(true)
            iframeDoc.body.appendChild(clonedContent)

            iframe.contentWindow.focus()
            iframe.contentWindow.print()

            setTimeout(() => {
                document.body.removeChild(iframe)
                resolve()
            }, 100)
        }, delay)
    })
}
